import { useState, useEffect } from 'react';

export const useSearchSuggestions = (input, events, maxSuggestions = 3) => {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (!input || !events) {
      setSuggestions([]);
      return;
    }

    const lowerInput = input.toLowerCase();
    const filteredSet = new Set();

    events.forEach((event) => {
      if (event.title?.toLowerCase().startsWith(lowerInput)) {
        filteredSet.add(event.title);
      }
      if (event.venue?.name?.toLowerCase().startsWith(lowerInput)) {
        filteredSet.add(event.venue.name);
      }
      event.categories?.forEach((category) => {
        if (category.name?.toLowerCase().startsWith(lowerInput)) {
          filteredSet.add(category.name);
        }
      });
    });

    const filteredArray = Array.from(filteredSet).slice(0, maxSuggestions);
    setSuggestions(filteredArray);
  }, [input, events, maxSuggestions]);

  return suggestions;
};
